
export const commonColumn = (header, accessorKey, Footer = null, align) => ({
  id: accessorKey,
  header,
  accessorKey,
  Footer,
  meta: { style: { textAlign: align } }
});

// ✅ SERIAL NUMBER COLUMN
export const serialNumberColumn = {
  id: "slNo",
  header: "Sl.No",
  cell: ({ row }) => row.index + 1,
  Footer: "Total",
  meta: { style: { textAlign: "left" } },
};
